module.exports = __webpack_public_path__ + "static/img/equip-1.d930f850.png";